<script>
import { Bar } from 'vue-chartjs';
import { formatCurrency } from '../../utils';

const options = {
	responsive: true,
	maintainAspectRatio: false,
	scales: {
		yAxes: [
			{
				display: true,
				ticks: {
					callback(value) {
						return '$ ' + formatCurrency(value);
					},
					beginAtZero: true
				}
			}
		]
	},
	legend: {
		position: 'bottom',
	},
	tooltips: {
		callbacks: {
				label: function(tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || '';

						if (label) {
								label += ': ';
						}
						label += '$' + formatCurrency(tooltipItem.yLabel);
						return label;
				}
		}
	}
};

export default {
	extends: Bar,
	props: ['data'],
	mounted() {
		this.renderChart(this.data, options);
	},

	watch: {
		data(newData, oldData) {
			this.renderChart(newData, options);
		}
	}
};
</script>
